import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Role } from '@bloomays-lib/types.shared';
import { TitlePart } from '@bloomays-lib/ui.shared';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatDateToMonthYear, getDefaultPrimeReferenceDate } from '../../utils/monthlyPrime.utils';
import { useAuthStore } from '../../stores';
import hourglass from '../../graphic-charter/illustrations/hourglass.png';
import PrimesTamNav from '../molecules/PrimesTamNav';
import MonthlyPrimeTamSelect from '../molecules/MonthlyPrimeTamSelect';
import MonthlyPrimeMonthSelect from '../molecules/MonthlyPrimeMonthSelect';
import { PageHeader } from '../molecules/PageHeader';

const Primes = () => {
  const { t } = useTranslation(['primes']);
  const navigate = useNavigate();
  const auth = useAuthStore((state) => state.auth);
  const [selectedTamEmail, setSelectedTamEmail] = useState('');
  const [selectedReferenceDate, setSelectedReferenceDate] = useState(getDefaultPrimeReferenceDate);

  const isAdmin = auth?.user?.roles?.includes(Role.Admin) || false;
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;
  const showMonthlyPrime = isAdmin && !isSystem;
  const showPrimeRoutes = showMonthlyPrime || (isSystem && Boolean(selectedTamEmail));

  if (!isAdmin && !isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  return (
    <Container>
      <PageHeader id="titlePrimes" title={t('title')}>
        {isSystem ? (
          <>
            <MonthlyPrimeTamSelect selectedTamEmail={selectedTamEmail} onTamChange={setSelectedTamEmail} />
            <MonthlyPrimeMonthSelect
              referenceDate={selectedReferenceDate}
              onReferenceDateChange={(date) => {
                setSelectedReferenceDate(date);
                navigate(`/primes/${formatDateToMonthYear(date)}`);
              }}
            />
          </>
        ) : null}
      </PageHeader>

      {showPrimeRoutes ? (
        <>
          <PrimesTamNav />
          <Outlet
            context={
              isSystem
                ? {
                    tamEmail: selectedTamEmail,
                    tamDisplayName: selectedTamEmail,
                    referenceDate: selectedReferenceDate,
                  }
                : undefined
            }
          />
        </>
      ) : (
        <ComingSoonContainer>
          <Image src={hourglass} alt="" />
          <TitlePart textTitle={t('comingSoon')} />
        </ComingSoonContainer>
      )}
    </Container>
  );
};

export default Primes;

const Container = styled('div')(({ theme }) => ({
  margin: 'auto',
  width: '90%',
}));

const ComingSoonContainer = styled('div')(() => ({
  marginTop: '32px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
}));

const Image = styled('img')(() => ({
  maxWidth: '280px',
  width: '100%',
  height: 'auto',
}));
